import { Http } from '@/model/Http.js'

export default class official extends Http {

  //用户套餐及公众号信息
  publicLogin(data){
    const url = 'api/public/go/login'
    return this.postAjax(url, {
       ...data
    })
  }

  //获取用户已授权公众号数据
  getAuthPublicList(data){
    const url = 'api/public/change'
    return this.postAjax(url, {
       ...data
    })
  }

  //获取平台绑定密码
  getSecret(data){
    const url = 'api/public/get-secret'
    return this.postAjax(url, {
      ...data
    })
  }
}



// WEBPACK FOOTER //
// ./src/javaApi/official.js